import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import user_placeholder from "../../../assets/images/user-placeholder.jpg";
import Logout from "../Logout.vue";
export default {
  components: {
    Logout: Logout
  },
  data: function data() {
    return {
      placeholder: user_placeholder
    };
  },
  computed: _objectSpread({}, mapState({
    myProfile: function myProfile(state) {
      return state.profile.myProfile.data;
    }
  }))
};